import { useSuspenseQuery, skipToken } from "@apollo/client";
import {
    GroupMembersProspectsDocument,
    GroupMembersProspectsQuery,
    GroupMembersProspectsQueryVariables,
} from "generated/graphql";

export const useGroupMembersProspects = (gcDepartureId?: string) => {
    const { data } = useSuspenseQuery<
        GroupMembersProspectsQuery,
        GroupMembersProspectsQueryVariables
    >(
        GroupMembersProspectsDocument,
        gcDepartureId
            ? {
                  variables: {
                      gcDepartureId,
                  },
                  context: { fetchOptions: { cache: "no-store" } },
              }
            : skipToken,
    );

    if (
        data?.gcDepartureProspects.__typename !==
        "GCDepartureProspectPaginatedResult"
    ) {
        return {
            gcDepartureProspects: [],
        };
    }

    return {
        gcDepartureProspects: data.gcDepartureProspects.results,
    };
};
